import { IDriveViewFolderDeletePreview } from '@commenda/types/src/drive-view/types';
import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IGetFolderDeletePreviewParams {
  folderId: string;
}

export async function getFolderDeletePreview({
  folderId,
}: IGetFolderDeletePreviewParams): Promise<
  IApiResponse<IDriveViewFolderDeletePreview>
> {
  const response = await fetcher(`drive-view/folder/${folderId}/delete-preview`, {
    method: 'GET',
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to get delete preview',
      statusCode: response.status,
      data: null,
    };
  }

  const body = await response.json();
  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: body.preview as IDriveViewFolderDeletePreview,
  };
}
